import { Button, Icon } from '@aon/aon-tws-common-ui';
import { bodyCopySmall, cappedHeaderSmall } from '@aon/aon-tws-common-ui/build/lib/globalCss';
import ReactHtmlParser from 'html-react-parser';
import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { ISummaryItem, SummaryDisplayType } from '../../../models';
import { ErrorWarningDisplay } from './ErrorWarningDisplay';
import { NoValue } from './NoValue';
import { SummaryItemDateHelper } from './SummaryItemDateHelper';

export const RowSummaryItemLayout = styled.div.attrs<{}>({
	className: 'tws-table-row-summary-item',
})`
	${bodyCopySmall}

	display: flex;
	margin-bottom: 15px;

	.tws-i-icon {
		cursor: pointer;
	}
`;
RowSummaryItemLayout.displayName = 'RowSummaryItemLayout';

export const DisplayName = styled.div.attrs<{}>({
	className: 'tws-table-row-summary-item-label',
})`
	${cappedHeaderSmall} {
		display: flex;
		flex: 1 1 30%;
		flex-direction: column;
		height: 100%;
		justify-content: start;
		line-height: inherit;
		vertical-align: top;
	}
`;
DisplayName.displayName = 'DisplayName';

export const DisplayValue = styled.div`
	 {
		display: flex;
		flex: 1 1 70%;
		flex-direction: column;
		height: 100%;
		justify-content: center;
		vertical-align: top;
	}
`;
DisplayValue.displayName = 'DisplayValue';

export const DisplayValueContent = styled.div.attrs<{ scroll?: boolean }>({
	className: 'tws-table-row-summary-item-value',
})<{ scroll?: boolean }>`
	 {
		${(props) =>
			props.scroll
				? `
		overflow-y: auto;
		max-height: 100px;
		width: 100%;
	`
				: ''}
	}
`;
DisplayValueContent.displayName = 'DisplayValueContent';

export const PopoutListButton = styled(Button).attrs<{}>({
	id: 'OpenPopoutList',
	'aria-label': 'Open Popout List',
	className: 'tws-summary-item-popout-list-toggle',
	color: 'transparent',
})``;

export type RowSummaryItemProps = ISummaryItem & {
	hasPopoutList?: boolean;
	hasScrollableContent?: boolean;
	toggleModal?: () => void;
};

export class RowSummaryItem extends React.Component<React.PropsWithChildren<RowSummaryItemProps>> {
	public render() {
		const { children, displayName, errors, hasPopoutList, hasScrollableContent, toggleModal, warnings } = this.props;
		const value = this.getDisplayContent();

		return (
			<RowSummaryItemLayout>
				<DisplayName>{displayName}</DisplayName>
				<DisplayValue>
					<DisplayValueContent scroll={hasScrollableContent}>
						{value !== null && ReactHtmlParser(value)}
						{value === null && NoValue}
						{hasPopoutList && children !== undefined && (
							<PopoutListButton onClick={toggleModal}>
								<Icon aria-hidden='true' name='open-modal' />
							</PopoutListButton>
						)}

						{children}
						<ErrorWarningDisplay errors={errors} warnings={warnings} />
					</DisplayValueContent>
				</DisplayValue>
			</RowSummaryItemLayout>
		);
	}

	private getDisplayContent() {
		const { displayType, value } = this.props;
		switch (displayType) {
			case SummaryDisplayType.PlainText:
			case SummaryDisplayType.PlainTextScrollable:
			case SummaryDisplayType.PopOutList:
				return value;
			case SummaryDisplayType.Date:
				return SummaryItemDateHelper.getDate(value);
			case SummaryDisplayType.DateRange:
				if (!value) {
					return null;
				}

				if (value.openImmediately && !value.openOn) {
					const closeOn = SummaryItemDateHelper.getDate(value.closeOn);
					return `${ContentConstants.AUDIENCE_OPENCLOSEDATES_OPENIMMEDIATELY} - ${closeOn}`;
				}
				return SummaryItemDateHelper.getDateRange([value.openOn, value.closeOn]);
			case SummaryDisplayType.TextWithDetails:
				return value && value.displayValue;
		}
	}
}
